module.exports = "img/logo-transparent.9868dd.png";